import React from "react";
import {
  RichTextContentBase,
  Content,
  Section,
  LinkIcon,
} from "./rich-text-content.styled";
import { RichTextSliceFragment } from "../../types/graphql";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import { contentPostSerializer } from "../../utils/htmlSerializer";
import { textToHTMLAttribute } from "../../utils/contentUtils";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";
import * as FA from "../../styles/fontawesome";

export type IRichTextContentProps = Slice<
  SharedSliceType.rich_text,
  RichTextSliceFragment["primary"]
> & { type: SharedSliceType };

const RichTextContent = ({
  slice,
  context,
}: SliceComponentProps<IRichTextContentProps, IPageContext>) => {
  const textSize = slice.primary?.text_size;
  const padding = slice.primary?.padding;

  const renderContent = (content: JSX.Element) => {
    const title = slice.primary?.title1;

    // If title not set then don't support anchor tags
    if (!title) return content;
    if (!context?.showHeadingAnchors) {
      return (
        <>
          <h3>{title}</h3>
          {content}
        </>
      );
    }
    // Generate Html friendly dash-case from H-Tag text
    const anchorID = textToHTMLAttribute(title);
    return (
      <Section id={anchorID}>
        <h3>
          <LinkIcon className="heading-anchor" href={`#${anchorID}`}>
            <i css={FA.LinkLight} />
          </LinkIcon>
          {title}
        </h3>
        {content}
      </Section>
    );
  };

  const baseContent = (
    <>
      {slice.primary?.rich_text && (
        <Content className={`text-${textSize || "base"}`}>
          <PrismicRichText
            field={slice.primary?.rich_text.richText}
            components={contentPostSerializer}
          />
        </Content>
      )}
    </>
  );

  return (
    <RichTextContentBase
      className={`slice-section ${padding}`}
      isHighlighted={slice.primary?.highlight_section}
    >
      <div className="container">{renderContent(baseContent)}</div>
    </RichTextContentBase>
  );
};

export default RichTextContent;
